import {
  Button,
  Classes,
  Dialog,
  FormGroup,
  InputGroup,
} from "@blueprintjs/core";
import {
  MDBCol,
  MDBRow,
} from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { IViewModel } from "mobx-utils";
import * as React from "react";
import { IUsuario } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { PerfilStore } from "../../stores/perfil/PerfilStore";
import { toast } from "react-toastify";
import Cookies from 'universal-cookie';
import { api } from "../../api";
const cookies = new Cookies()

interface EditUserDialogProps {
  onClose: () => void;
}

interface EditUserDialogState {
  conta_id: any;
}

@observer
export class EditUserDialog
  extends React.Component<EditUserDialogProps, EditUserDialogState>
{
  obs = observable({
    usuario: null as IUsuario & IViewModel<IUsuario>,
    focusDone: false as boolean,
    currentPassword: "" as string,
    newPassword: "" as string,
    working: false as boolean,
    conta_id: [] as any,
    nome_completo: PerfilStore.obs.usuario_edit.nome_completo as string,
    email: PerfilStore.obs.usuario_edit.email as string,
    senha: "" as string,
    newList: [""] as string[],
    edit_permi: true as boolean,
  })


  focusFirst(el: HTMLInputElement) {
    if (!this.obs.focusDone) {
      el.focus();
      this.obs.focusDone = true;
    }
  }

  handleCheckChange = (permissao: string) => {
    if (this.obs.newList.indexOf(permissao) < 0) {
      this.obs.newList.push(permissao);
    } else {
      this.obs.newList.splice(this.obs.newList.indexOf(permissao), 1);
    }
  };

  refresh = () => {
    window.location.reload();
  };

  async componentDidMount() {
    this.setState({ conta_id: AppStore.obs1.contaId });
    this.obs.newList = [...PerfilStore.obs.usuario_edit.niveis_acesso];
  }

  handleEditUser = async () => {

    let regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/

    if (!this.obs.nome_completo) {
      toast.error('Preencha o nome do usuário', {});
      return;
    }
    if (!this.obs.email) {
      toast.error('Preencha o email do usuário', {});
      return;
    }

    if (!regex.test(this.obs.email)) {
      toast.warning("E-mail inválido!", {});
      return
    }

    try {
      let params = {
        id_user: PerfilStore.obs.usuario_edit.id,
        nome_completo: this.obs.nome_completo,
        email: this.obs.email,
        niveis_acesso: this.obs.newList,
      }

      let resp = await api.post("/api/update-usuario-conta", params)

      if (resp.data.ok) {
        this.props.onClose();

        toast.success('Usuário atualizado com sucesso', {});

        setInterval(this.refresh, 1000);
      } else {
        toast.error(resp.data.msg, {});
      }

    } catch (ex) {
      toast.error('Não foi possível atualizar o usuário, contate o suporte para mais detalhes.', {});
    }
  };

  render() {
    return (
      <Dialog isOpen title="Editar Usuário" onClose={this.props.onClose}>
        <div className={Classes.DIALOG_BODY}>
            <FormGroup
              label="Nome Completo"
              labelInfo="(obrigatório)"
            >
              <InputGroup
                defaultValue={this.obs.nome_completo}
                onChange={(e: any) => this.obs.nome_completo = e.target.value}
              />
            </FormGroup>

          <FormGroup
            label="E-mail para Acesso"
            labelFor="current-password"
            labelInfo="(obrigatório)"
          >
            <InputGroup
              name='new-email'
              autoComplete='new-email'
              style={{ width: "100%" }}
              defaultValue={this.obs.email}
              onChange={(e: any) => this.obs.email = e.target.value}
            />
          </FormGroup>

          <h2 className="title title-permissoes">Permissões selecionadas:</h2>
          <Button
            text="Redefinir Permissões"
            className="alterPermission"
            onClick={() => this.obs.edit_permi = false}
            disabled={this.obs.working}
          />
          <MDBRow>
            <MDBCol xl="4" md="4" sm="4" xs="12">
              <FormGroup
                label="Empresas"
                labelFor="current-password"
              >
                <input
                  type="checkbox"
                  checked={this.obs.newList.indexOf("e1") != -1}
                  disabled={this.obs.edit_permi}
                  defaultChecked={this.obs.newList.indexOf("e1") != -1}
                  className="chaves"
                  value="e1"
                  onChange={() => this.handleCheckChange("e1")}
                />{" "}
                Criar <br />
                <input
                  type="checkbox"
                  checked={this.obs.newList.indexOf("e2") != -1}
                  disabled={this.obs.edit_permi}
                  defaultChecked={this.obs.newList.indexOf("e2") != -1}
                  className="chaves"
                  value="e2"
                  onChange={() => this.handleCheckChange("e2")}
                />{" "}
                Alterar <br />
                <input
                  type="checkbox"
                  checked={this.obs.newList.indexOf("e3") != -1}
                  disabled={this.obs.edit_permi}
                  defaultChecked={this.obs.newList.indexOf("e3") != -1}
                  className="chaves"
                  value="e3"
                  onChange={() => this.handleCheckChange("e3")}
                />{" "}
                Deletar <br />
              </FormGroup>
            </MDBCol>
            <MDBCol xl="4" md="4" sm="4" xs="12">
              <FormGroup
                label="Cálculos"
                labelFor="current-password"
              >
                <input
                  type="checkbox"
                  checked={this.obs.newList.indexOf("c1") != -1}
                  disabled={this.obs.edit_permi}
                  defaultChecked={this.obs.newList.indexOf("c1") != -1}
                  className="chaves"
                  value="c1"
                  onChange={() => this.handleCheckChange("c1")}
                />{" "}
                Visualizar <br />
                <input
                  type="checkbox"
                  checked={this.obs.newList.indexOf("c2") != -1}
                  disabled={this.obs.edit_permi}
                  defaultChecked={this.obs.newList.indexOf("c2") != -1}
                  className="chaves"
                  value="c2"
                  onChange={() => this.handleCheckChange("c2")}
                />{" "}
                Contestar <br />
                <input
                  type="checkbox"
                  checked={this.obs.newList.indexOf("c3") != -1}
                  disabled={this.obs.edit_permi}
                  defaultChecked={this.obs.newList.indexOf("c3") != -1}
                  className="chaves"
                  value="c3"
                  onChange={() => this.handleCheckChange("c3")}
                />{" "}
                Exportar <br />
                <input
                  type="checkbox"
                  checked={this.obs.newList.indexOf("c4") != -1}
                  disabled={this.obs.edit_permi}
                  defaultChecked={this.obs.newList.indexOf("c4") != -1}
                  className="chaves"
                  value="c4"
                  onChange={() => this.handleCheckChange("c4")}
                />{" "}
                Memória de Cálculos <br />
              </FormGroup>
            </MDBCol>
            <MDBCol xl="4" md="4" sm="4" xs="12">
              <FormGroup
                label="Histórico de NF-es"
                labelFor="current-password"
              >
                <input
                  type="checkbox"
                  checked={this.obs.newList.indexOf("h1") != -1}
                  disabled={this.obs.edit_permi}
                  defaultChecked={this.obs.newList.indexOf("h1") != -1}
                  className="chaves"
                  value="h1"
                  onChange={() => this.handleCheckChange("h1")}
                />{" "}
                Visualizar <br />
                <input
                  type="checkbox"
                  checked={this.obs.newList.indexOf("h2") != -1}
                  disabled={this.obs.edit_permi}
                  defaultChecked={this.obs.newList.indexOf("h2") != -1}
                  className="chaves"
                  value="h2"
                  onChange={() => this.handleCheckChange("h2")}
                />{" "}
                Manifestar <br />
                <input
                  type="checkbox"
                  checked={this.obs.newList.indexOf("h3") != -1}
                  disabled={this.obs.edit_permi}
                  defaultChecked={this.obs.newList.indexOf("h3") != -1}
                  className="chaves"
                  value="h3"
                  onChange={() => this.handleCheckChange("h3")}
                />{" "}
                Envios e Download <br />
              </FormGroup>
            </MDBCol>
            <MDBCol xl="4" md="4" sm="4" xs="12">
              <FormGroup
                label="Importar XMLs"
                labelFor="current-password"
              >
                <input
                  type="checkbox"
                  checked={this.obs.newList.indexOf("i1") != -1}
                  disabled={this.obs.edit_permi}
                  defaultChecked={this.obs.newList.indexOf("i1") != -1}
                  className="chaves"
                  value="i1"
                  onChange={() => this.handleCheckChange("i1")}
                />{" "}
                Importar <br />
              </FormGroup>
            </MDBCol>
            <MDBCol xl="4" md="4" sm="4" xs="12">
              <FormGroup
                label="Logs"
                labelFor="current-password"
              >
                <input
                  type="checkbox"
                  checked={this.obs.newList.indexOf("l1") != -1}
                  disabled={this.obs.edit_permi}
                  defaultChecked={this.obs.newList.indexOf("l1") != -1}
                  ref="check_permission"
                  className="chaves"
                  value="l1"
                  onChange={() => this.handleCheckChange("l1")}
                />{" "}
                Visualizar <br />
              </FormGroup>
            </MDBCol>
            <MDBCol xl="4" md="4" sm="4" xs="12">
              <FormGroup
                label="Perfil"
                labelFor="current-password"
              >
                <input
                  type="checkbox"
                  checked={this.obs.newList.indexOf("p1") != -1}
                  disabled={this.obs.edit_permi}
                  defaultChecked={this.obs.newList.indexOf("p1") != -1}
                  ref="check_permission"
                  className="chaves"
                  value="p1"
                  onChange={() => this.handleCheckChange("p1")}
                />{" "}
                Criar, Alterar e Deletar <br />
              </FormGroup>
            </MDBCol>
          </MDBRow>
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button
              text="Cancelar"
              onClick={this.props.onClose}
              disabled={this.obs.working}
            />
            <Button
              text="Salvar"
              intent="primary"
              onClick={this.handleEditUser}
              loading={this.obs.working}
            />
          </div>
        </div>
      </Dialog>
    );
  }
}
